export default "__VITE_ASSET__BjEabuoJ__"